import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { AngularSvgIconModule } from "angular-svg-icon";
import { AdminPageContainerComponent } from "src/app/components/ape-admin-page-container/ape-admin-page-container.component";
import { ApeButtonComponent } from "src/app/components/ape-button/ape-button.component";
import { ApeDownloadButtonComponent } from "src/app/components/ape-download-button/ape-download-button.component";
import { ApeInputComponent } from "src/app/components/ape-input/ape-input.component";
import { ApeModalComponent } from "src/app/components/ape-modal/ape-modal.component";
import { ApeMonitoringDetailsFilterProcessDrawerComponent } from "src/app/components/ape-monitoring-details-filter-process-drawer/ape-monitoring-details-filter-process-drawer.component";
import { ApePagePlaceholderComponent } from "src/app/components/ape-page-placeholder/ape-page-placeholder.component";
import { ApeProcessSetupSkeletonComponent } from "src/app/components/ape-process-setup-skeleton/ape-process-setup-skeleton.component";
import { ApeSelectComponent } from "src/app/components/ape-select/ape-select.component";
import { ApeStatusBadgeComponent } from "src/app/components/ape-status-badge/ape-status-badge.component";
import { ApeTablePaginationComponent } from "src/app/components/ape-table-pagination/ape-table-pagination.component";
import { TranslatePipe } from "src/app/pipe/translation.filter.pipe";
import { MonitoringDetailsCountersTemplateComponent } from "../monitoring-details-counters-template/monitoring-details-counters-template.component";
import { ApeMonitoringDetailsTemplateComponent } from "../process-monitoring-details-template/process-monitoring-details-template.component";
import { ApeAdminMonitoringUsersDevelopmentPlanTableComponent } from "src/app/components/ape-admin-monitoring-users-development-plan-table/ape-admin-monitoring-users-development-plan-table.component";
import { PhaseStatusEnumTypes, ProcessStatusEnumTypes } from "alloy-performance-engine-cl";
import { MonitoringUserDevelopmentPlanSummaryExtended } from "src/app/services/api/monitoring-backoffice-api.service";

@Component({
  selector: "process-monitoring-development-plan-details-template",
  standalone: true,
  host: { class: "w-full h-full" },
  templateUrl: "./process-monitoring-development-plan-details-template.component.html",
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslatePipe,
    AdminPageContainerComponent,
    MonitoringDetailsCountersTemplateComponent,
    ApeTablePaginationComponent,
    ApeButtonComponent,
    ApeMonitoringDetailsFilterProcessDrawerComponent,
    ApePagePlaceholderComponent,
    ApeInputComponent,
    AngularSvgIconModule,
    ApeStatusBadgeComponent,
    ApeSelectComponent,
    ApeProcessSetupSkeletonComponent,
    ApeModalComponent,
    ApeProcessSetupSkeletonComponent,
    ApeDownloadButtonComponent,
    ApeAdminMonitoringUsersDevelopmentPlanTableComponent
  ]
})
export class ApeMonitoringDevelopmentPlanDetailsTemplateComponent extends ApeMonitoringDetailsTemplateComponent {
  @Input() isLoadingSolicitMassiveDevelopmentPlan: boolean = false;

  protected isVisibleSolicitDevelopmentPlanModal: boolean = false;

  protected isVisibleSolicitMassiveDevelopmentPlanModal: boolean = false;

  @Output() onSolicitMassiveDevelopmentPlan = new EventEmitter<void>();

  @Output() onSolicitDevelopmentPlan = new EventEmitter<MonitoringUserDevelopmentPlanSummaryExtended>();

  protected get isSolicitMassiveDevelopmentPlanDisabled(): boolean {
    if (!this.usersData || !this.processStatus || !this.processPhases) {
      return true;
    }
    // se il processo non è attivo, il pulsante deve essere disabilitato
    // se la fase di self evaluation non è attiva, il pulsante deve essere disabilitato
    // se non ho utennti in tabella, torno false
    if (this.usersData.length === 0) {
      return true;
    }
    if (!this.processPhases?.developmentPlanPhase?.status) {
      return true;
    }
    // disattivo se non c'è nessuno che può essere sollicitato
    if (this.allUsersData.every(user => !user.canSolicitDevelopmentPlan)) {
      return true;
    }
    if (this.isLoadingSolicitMassiveDevelopmentPlan) {
      return true;
    }
    return this.processStatus !== ProcessStatusEnumTypes.ACTIVE || this.processPhases?.developmentPlanPhase?.status !== PhaseStatusEnumTypes.ACTIVE;
  }

  protected get isPhaseActive(): boolean {
    return this.processPhases?.developmentPlanPhase?.status === PhaseStatusEnumTypes.ACTIVE;
  }

  protected showSolicitMassiveDevelopmentPlanModal() {
    this.isVisibleSolicitMassiveDevelopmentPlanModal = true;
  }

  protected onCancelSolicitMassiveDevelopmentPlan() {
    this.isVisibleSolicitMassiveDevelopmentPlanModal = false;
  }

  protected async onConfirmSolicitMassiveDevelopmentPlan() {
    if (!this.processId) {
      this.logger.error(`Cannot solicit massive development plan missing processId (${this.processId})`);
      this.onCancelSolicitMassiveDevelopmentPlan();
      return;
    } else {
      try {
        this.isLoadingSolicitMassiveDevelopmentPlan = true;
        this.isVisibleSolicitMassiveDevelopmentPlanModal = false;
        await this.monitoringBackofficeApiService.solicitAllUsersDevelopmentPlan(this.processId);
        this.onSolicitMassiveDevelopmentPlan.emit();
      } catch (error) {
        this.logger.error(`Error soliciting massive development plan: ${error?.toString()}`);
        this.alertService.showError(this.translate.instant("admin.monitoring.details.SOLICIT_MASSIVE_DEVELOPMENT_PLAN_ERROR"));
      } finally {
        this.isVisibleSolicitMassiveDevelopmentPlanModal = false;
        this.isLoadingSolicitMassiveDevelopmentPlan = false;
      }
    }
  }

  protected showSolicitDevelopmentPlanModal(user: MonitoringUserDevelopmentPlanSummaryExtended) {
    this.selectedUser = user;
    this.isVisibleSolicitDevelopmentPlanModal = true;
  }

  protected onConfirmSolicitDevelopmentPlan() {
    if (this.selectedUser) {
      this.onSolicitDevelopmentPlan.emit(this.selectedUser as MonitoringUserDevelopmentPlanSummaryExtended);
    }
    this.isVisibleSolicitDevelopmentPlanModal = false;
  }

  protected onCancelSolicitDevelopmentPlan() {
    this.isVisibleSolicitDevelopmentPlanModal = false;
  }
}